<template>
  <div
    style="padding-left: 2%; padding-right: 2%; padding-bottom: 2%; background-color: #F8F9FA; min-height: 100vh; height: 100%;"
  >
    <!-- <Title /> -->
    <OverlayLoading :loading="loading" />
    <v-row class="d-flex align-center ma-0 pt-2">
      <span class="header-title ml-0">
        รายละเอียดข้อมูล
      </span>
      <v-spacer />
    </v-row>
    <v-card height="auto" min-height="82vh" class="pt-7 pb-7" >
      <v-container fluid pa-0 >
          <v-row align="center" justify="center" >
            <div class="pt-1 pb-4 rounded-0" style="min-width:50vw; width:70vw; max-width:100vw;">
              <div class="text-left">
                <span class="blue--text text--darken-4 font-weight-bold mr-5 text-title-content">ข้อมูลเพื่อเข้าร่วมกับบริษัท</span>
              </div>
              <v-divider class="mt-1 mb-4"/>
              <v-row justify="center" align="center">
                <div
                  class="box-employeeimg ml-0 mt-4"
                  @click="ChooseBanner()"
                  style="height: 200px; width: 200px; background-size: contain; background-repeat: no-repeat; cursor: default;"
                >
                  <div class="pa-0 box-placeholderimg">
                    <div
                      class="placeholderimg"
                      :style="{ 'background-image': `url(${imageUrl})` }"
                    >
                      <v-img
                        v-if="!imageUrl"
                        width="150"
                        height="150"
                        contain
                        :src="require('@/assets/icons/company-logo3.png')"
                        aspect-ratio="1"
                      />
                      <input
                        class="file-input"
                        id="files"
                        ref="Pickfiles"
                        type="file"
                        :disabled="!valid"
                        accept="image/*"
                        v-on:change="onBannerSelected()"
                      />
                    </div>
                  </div>
                </div>
              </v-row>
              <div :style="$vuetify.breakpoint.name === 'xl' ? 'margin-left: 7%;' :
              $vuetify.breakpoint.name === 'lg' ? 'margin-left: 14%;' :
              $vuetify.breakpoint.name === 'xs' ? 'margin-left: 14%;' :
              $vuetify.breakpoint.name === 'md' ? 'margin-left: 12%;' :
              $vuetify.breakpoint.name === 'sm' ? 'margin-left: 18%;' :
              'margin-left: 12%;'">
                <v-row justify="center" align="center" class="pl-0">
                  <v-col cols="12" xl="3" lg="5" sm="8" md="6" class="text-left">
                    <span class="txt-font" style="margin-top: 0%;">
                      ชื่อบริษัท:
                    </span>
                    <span class="txt-font-value" style="color: #333;">
                      <!-- {{tokenUser.company.companyShortNameEng !== '' ? tokenUser.company.companyShortNameEng : ''}} {{tokenUser.company.companyShortNameEng !== '' ? tokenUser.company.companyShortNameEng : ''}} {{tokenUser.company.companyFullNameTh || ''}}</span> -->
                       {{tokenUser.company.companyFullNameTh || ''}}
                      <span v-if="tokenUser.company.companyShortNameTh !== ''">({{tokenUser.company.companyShortNameTh !== '' ? tokenUser.company.companyShortNameTh : ''}})</span></span>
                  </v-col>
                </v-row>
                   <v-row justify="center" align="center" class="pl-0">
                  <v-col cols="12" xl="3" lg="5" sm="8" md="6" class="text-left">
                    <span class="txt-font" style="margin-top: 0%;">
                      ประเภทนิติบุคคล:
                    </span>
                    <span class="txt-font-value" style="color: #333;">
                      <!-- {{tokenUser.company.companyShortNameEng !== '' ? tokenUser.company.companyShortNameEng : ''}} {{tokenUser.company.companyShortNameEng !== '' ? tokenUser.company.companyShortNameEng : ''}} {{tokenUser.company.companyFullNameTh || ''}}</span> -->
                       {{tokenUser.company.legalEntityTh !== '' ? tokenUser.company.legalEntityTh : '-'}} </span>
                  </v-col>
                </v-row>
                <v-row justify="center" align="center" class="pl-0">
                  <v-col cols="12" xl="3" lg="5" sm="8" md="6" class="text-left">
                    <span class="txt-font" style="margin-top: 0%;">
                      ชื่อ-นามสกุล:
                    </span>
                    <span class="txt-font" style="color: #333;"
                      >{{ tokenUser.userJoin.titleTh || '-' }}{{ tokenUser.userJoin.firstNameTh || ''}} {{ tokenUser.userJoin.lastNameTh || ''}}</span>
                  </v-col>
                </v-row>
                 <v-row justify="center" align="center" class="pl-0">
                  <v-col cols="12" xl="3" lg="5" sm="8" md="6" class="text-left">
                    <span class="txt-font" style="margin-top: 0%;">
                      Email:
                    </span>
                    <span class="txt-font" style="color: #333;"
                      >{{ tokenUser.userJoin.email || '-' }}</span>
                  </v-col>
                </v-row>
                <v-row justify="center" align="center" class="px-0">
                  <v-col cols="12" xl="3" lg="5" sm="8" md="6" class="text-left">
                    <span class="txt-font" style="margin-top: 0%;">
                      วันที่เข้าร่วม:
                    </span>
                    <span class="txt-font" style="color: #333;"
                      >{{initDate(tokenUser.tokenJoin.sessionStart) || '-'}} น.</span>
                  </v-col>
                </v-row>
                <v-row justify="center" align="center" class="px-0">
                  <v-col cols="12" xl="3" lg="5" sm="8" md="6" class="text-left">
                    <span class="txt-font" style="margin-top: 0%;">
                      สถานะ:
                    </span>
                    <v-chip
                      :color="['approve','acknowledge', 'active', 'เข้าร่วมแล้ว'].includes(status)? '#ECF8EA': ['reject', 'expire'].includes(status)? '#FBE5E4': ['pending', 'มีใบคำร้องอยู่'].includes(status)? '#FEF5E9': ['cancel', 'ยังไม่เข้าร่วม'].includes(status)? '#F5F5F5':'#ECF9FF'"
                      :text-color="statusList.filter(e => e.status === status)[0].color"
                    >
                      <span>{{ statusList.filter(e => e.status === status)[0].statusTH || '' }}</span>
                    </v-chip>
                  </v-col>
                </v-row>
              </div>
              <v-row justify="center" align="center">
                <v-btn v-if="localStorageData.canJoin === 'false'" class="ma-2 mr-2" color="grey" depressed disabled>ขอเข้าร่วม</v-btn>
                <v-btn v-else class="ma-2 mr-5" color="#3776E9" dark @click="joinCompany()">ขอเข้าร่วม</v-btn>
              </v-row>
          </div>
        </v-row>
      </v-container>
    </v-card>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card height="170px">
        <v-card-title class="ra-head-text-bold justify-center pa-5"
          >ต้องการลบข้อมูลนี้ ใช่หรือไม่?</v-card-title
        >
        <v-card-text class="justify-center text-center">
          <span class="ra-head-text justify-center"
            >คุณแน่ใจหรือว่าต้องการลบข้อมูลนี้</span
          >
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn
            class="ra-button1"
            color="#1654C6"
            outlined
            @click="dialogDelete = false"
            >ยกเลิก</v-btn
          >
          <v-btn
            class="ra-button1"
            color="#1654C6"
            dark
            @click="removeEmployee(itemConfirmDelete)"
            >ลบข้อมูล</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-row>
        <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          :color="snackbarColor"
          text
          top
          app
        >
          <v-icon left dark small :color="snackbarColor"
            >fa-check-circle</v-icon
          >
          <span :style="{ color: `${snackbarColor}` }">{{ text }}</span>
        </v-snackbar>
      </v-row>
    </div>
  </div>
</template>

<script>
import OverlayLoading from '../../_template/OverlayLoading.vue'
// import FullLoading from '../../_template/FullLoading.vue'
// import { EventBus } from '@/EventBus'
import swal from 'sweetalert'
import {
// hostImageUrl,
// hostImageUrlv3
} from '@/API/API'
import moment from 'moment'
moment.locale('th')

export default {
  components: {
    OverlayLoading
  },
  name: 'create-new-employee',
  data () {
    return {
      snackbar: false,
      timeout: 2000,
      snackbarColor: '',
      text: '',
      dialogDelete: false,
      titleDialog: '',
      itemConfirmDelete: [],
      employeeData: [],
      localStorageData: '',
      temploralyData: [{
        no: 1
      }],
      itemIdex: 0,
      tab: null,
      items: ['ข้อมูลพนักงาน', 'ประวัติพนักงาน'],
      panel: [0, 1],
      typeText: null,
      activeTab: 1,
      loading: false,
      loadingProfileData: false,
      loadingEmployeeData: false,
      keySearchEmployee: [],
      date: new Date().toISOString().substr(0, 10),
      imgUser: null,
      imageUrl: null,
      itemDefault: [
        {
          orgChartName: 'ไม่มี',
          pid: null,
          _id: 'ไม่มี'
        }
      ],
      genderthlists: [],
      titleTH: '',
      titleEN: '',
      fnameTH: '',
      lnameTH: '',
      fnameEN: '',
      lnameEN: '',
      accountId: '',
      companyData: [],
      status: 'pending',
      birthDate: moment(new Date().toISOString().substr(0, 10)).format(
        'DD/MM/YYYY'
      ),
      email: '',
      tel: '',
      companyId: '',
      companyItems: [],
      rulesCompany: [v => !!v || 'กรุณาเลือกบริษัท'],
      employeeId: '',
      // startWorkDate: moment(new Date().toISOString().substr(0, 10)).format('DD/MM/YYYY'),
      startWorkDate: new Date().toISOString().substr(0, 10),
      endWorkDate: new Date().toISOString().substr(0, 10),
      valid: false,
      alertText: {
        'user is already': 'มีข้อมูลผู้ใช้ในระบบแล้ว',
        'employeeId is already': 'รหัสพนักงานซ้ำ',
        'chart not found': 'ไม่พบฝ่ายงานที่ต้องการ',
        'user not found': 'ไม่พบผู้ใช้งาน',
        'request is already': 'มีคำร้องนี้ในระบบแล้ว',
        'data incomplete': 'กรุณากรอกข้อมูลให้ครบถ้วน',
        "Cannot read properties of undefined (reading 'userId')": 'บริษัทยี้ยังไม่มีผู้อนุมัติ'
      },
      alertTextDetail: {
        'user is already': 'กรุณาลองใหม่อีกครั้ง',
        'employeeId is already': 'กรุณาลองใหม่อีกครั้ง',
        'chart not found': 'กรุณาลองใหม่อีกครั้ง',
        'user not found': 'กรุณาลองใหม่อีกครั้ง',
        'request is already': 'กรุณาอนุมัติคำร้องที่มีอยู่ในระบบ'
      },
      expand: false,
      statusList: [
        { status: 'pending', statusTH: 'รออนุมัติ', color: '#E9A016' },
        { status: 'มีใบคำร้องอยู่', statusTH: 'มีใบคำร้องอยู่', color: '#E9A016' },
        { status: 'approve', statusTH: 'อนุมัติแล้ว', color: '#58A144' },
        { status: 'เข้าร่วมแล้ว', statusTH: 'เข้าร่วมแล้ว', color: '#58A144' },
        { status: 'reject', statusTH: 'ไม่อนุมัติ', color: '#D1392B' },
        { status: 'cancel', statusTH: 'ยกเลิก', color: '#757575' },
        { status: 'ยังไม่เข้าร่วม', statusTH: 'ยังไม่เข้าร่วม', color: '#757575' },
        { status: 'acknowledge', statusTH: 'รับทราบแล้ว', color: '#58A144' },
        { status: 'active', statusTH: 'โอนสิทธิ์แล้ว', color: '#58A144' },
        { status: 'expire', statusTH: 'หมดอายุ', color: '#D1392B' },
        { status: 'inActive', statusTH: 'ยกเลิก', color: '#757575' }
      ],
      headers: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'no'
        },
        { text: 'รหัสพนักงาน', value: 'employeeId' },
        { text: 'ตำแหน่ง', value: 'position' },
        { text: 'สายบังคับบัญชา', value: 'orgChartName' },
        { text: 'บริษัท', value: 'companyFullName' },
        { text: 'ประเภท', value: 'tempLeader' }
        // { text: 'วันเวลาทำรายการ', value: 'email' }
        // { text: 'จัดการ', value: 'actions', sortable: false }
      ]
    }
  },
  mounted () {
    // EventBus.$on('addAprover', this.add)
  },
  beforeDestroy () {
    // EventBus.$off('addAprover')
  },
  async created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.propsitems = this.$store.state.user._id
    this.propsitemsTab = this.$route.params.tab
    this.tokenUser = this.$store.state
    this.localStorageData = localStorage
    this.status = this.localStorageData.statusJoin
    // console.log('tok', this.tokenUser)
    // console.log('Data', localStorage)
    // console.log('Data2', this.$store)
    // console.log('STATUS', this.status)
    if (!this.$store.state.token) {
    } else {
      await this.getEmployeeDetail(this.propsitems, this.propsitemsTab)
      // await this.getEmployeeDetail('5f87dee580c57d63cc030145', this.$route.params.tab)
    }
  },
  computed: {
    checkCompany () {
      return !!this.selectGroupCompany.length
    }
  },
  watch: {},
  methods: {
    goBack () {
      // this.$router.push('/manageemp')
    },
    gotoProfile () {
      const self = this
      self.activeTab = 1
      // console.log(self.activeTab)
    },
    async joinCompany () {
      let url = ''
      // urlEmp = `${this.api}/api/vMonk/manageEmployee/getUserData/`
      url = `${this.api}/api/vMonk/companys/registration`
      await this.axios({
        method: 'post',
        url: url,
        data: {
          companyId: this.tokenUser.company._id,
          titleTh: this.tokenUser.userJoin.titleTh,
          titleEn: this.tokenUser.userJoin.titleEn,
          firstNameTh: this.tokenUser.userJoin.firstNameTh,
          lastNameTh: this.tokenUser.userJoin.lastNameTh,
          firstNameEn: this.tokenUser.userJoin.firstNameEn,
          lastNameEn: this.tokenUser.userJoin.lastNameEn,
          accountId: this.tokenUser.userJoin.accountId,
          birthday: this.tokenUser.userJoin.birthday,
          emailOneId: this.tokenUser.userJoin.emailOneId,
          email: this.tokenUser.userJoin.email,
          userImg: this.tokenUser.userJoin.userImg
        },
        headers: {
          authorization: this.$store.state.token
        }
      })
        .then(response => {
          if (response.data.success) {
            // this.userId = response.data.result._id
            swal('สำเร็จ', 'คูณได้ขอเข้าร่วมบริษัทนี้แล้ว', 'success', {
              button: false,
              timer: 2000
            })
            localStorage.setItem('canJoin', 'false')
            localStorage.setItem('statusJoin', 'มีใบคำร้องอยู่')
          } else {
            swal('ผิดพลาด', `${this.alertText[response] || ''} กรุณาลองใหม่อีกครั้ง`, 'error', {
              button: false,
              timer: 2000
            })
          }
        })
        .catch(e => {
          console.log(e)
          swal('ผิดพลาด', `${this.alertText[e] || ''} กรุณาลองใหม่อีกครั้ง`, 'error', {
            button: false,
            timer: 2000
          })
        })
    },
    async getEmployeeDetail (id, tab) {
      this.axios({
        method: 'get',
        responseType: 'data',
        url: `${this.api}/api/vMonk/companys/getcompanyFileById/` + this.tokenUser.company.companyImage
      }).then((response) => {
        // this.imageUrl = this.imageUrl = `${this.api}/api/vMonk/companys/getcompanyFileById/` + '6046f4209d787d1eb4ba679a'
        this.imageUrl = this.imageUrl = `${this.api}/api/vMonk/companys/getcompanyFileById/` + this.tokenUser.company.companyImage
        // console.log('img', this.imageUrl)
      }).catch(e => {
        this.imageUrl = ''
        console.log(e)
      })
    },
    ChooseBanner () {
      this.$refs.Pickfiles.click()
    },
    onBannerSelected () {
      this.files = []
      var uploadedImage = this.$refs.Pickfiles.files
      var dotindex = uploadedImage[0].name.lastIndexOf('.')
      var FileExtension = uploadedImage[0].name
        .substr(dotindex + 1)
        .toLowerCase()
      if (
        FileExtension === 'jpg' ||
        FileExtension === 'png' ||
        FileExtension === 'JPG' ||
        FileExtension === 'PNG'
      ) {
        if (!uploadedImage[0]) return
        const reader = new FileReader()
        reader.readAsDataURL(uploadedImage[0])
        reader.onload = evt => {
          var imgUser = new Image()
          this.files.push(uploadedImage[0])
          // console.log(this.files[0])
          const fr = new FileReader()
          fr.readAsDataURL(this.files[0])
          fr.addEventListener('load', () => {
            this.nameimg = this.files[0].name
            this.imageUrl = fr.result
          })
          imgUser.src = evt.target.result
        }
      }
    },
    initDate (date) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    },
    onImgError (i, j) {
      this.dataEmployee[i].approver[j].failed_image = true
    },
    onImgErrorEmployee (i) {
      // this.approver[i].failed_image = true
    },
    formatWorkDate (date) {
      return date ? moment(date).format('yyyy-MM-DD') : 'ไม่มี'
      // return new Date(date) - new Date(date)
    },
    formatDate (date) {
      return date ? moment(date).format('DD/MM/YYYY HH:mm:ss') : 'ไม่มี'
      // return new Date(date) - new Date(date)
    },
    formatBirthDate (date) {
      return date ? moment(date).format('DD/MM/YYYY') : 'ไม่มี'
      // return new Date(date) - new Date(date)
    }
  }
}
</script>

<style scoped>
@import "../../../css/CreateEmployee.css";

.border-table-employee {
  border-radius: 10px;
  border: 1px solid rgb(229, 236, 238);
}

table > tbody > tr > td.fixed:nth-last-child(1),
table > thead > tr > th.fixed:nth-last-child(1) {
  position: sticky !important;
  position: -webkit-sticky !important;
  right: 0;
  /* z-index: 9997; */
  background: white;
  /* background: transparent; */
  -webkit-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  -moz-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
}

table > tbody > tr:hover > td.fixed:nth-last-child(1),
table > thead > tr:hover > th.fixed:nth-last-child(1) {
  background: #eeeeee;
}

table > thead > tr > th.fixed:nth-last-child(1) {
  /* z-index: 9998; */
  background-color: #f8f9fb;
}

.v-stepper {
  box-shadow: none !important;
}
.v-stepper__header {
  box-shadow: none !important;
}
.v-application {
  padding: 0 !important;
}
.maminus-5 {
  margin: 0 -20px !important;
}
.v-stepper__step {
  flex-direction: column !important;
}
.v-application--is-ltr .v-stepper__step__step {
  margin-right: 0 !important;
}
.theme--light.v-divider {
  border-color: rgb(229, 230, 231) !important;
}
.step-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: fit-content;
  height: fit-content;
  padding: 24px;
  position: relative;
}
.step-container:hover {
  cursor: pointer;
}
.step-container:hover .step-circle-inactive {
  /* border: 2px solid rgb(122, 212, 108) !important; */
  border: 2px solid #004682 !important;
}
.step-container:hover .step-circle-text-inactive {
  /* color:rgb(122, 212, 108) !important; */
  color: #004682 !important;
}
.step-container:hover .step-text-inactive {
  /* color:rgb(122, 212, 108) !important; */
  color: #004682 !important;
}
.step-circle-active {
  align-items: center;
  border-radius: 50%;
  display: inline-flex;
  font-size: 0.75rem;
  justify-content: center;
  height: 24px;
  min-width: 24px;
  width: 24px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background-color: transparent !important;
  /* border: 2px solid rgb(103, 173, 92) !important; */
  border: 2px solid #07d1bf !important;
}
.step-circle-text-active {
  font-weight: 600;
  /* color: rgb(103, 173, 92) !important; */
  color: #07d1bf !important;
}
.step-text-active {
  font-weight: 600;
  /* color: rgb(103, 173, 92) !important; */
  color: #07d1bf !important;
}
.step-circle-inactive {
  align-items: center;
  border-radius: 50%;
  display: inline-flex;
  font-size: 0.75rem;
  justify-content: center;
  height: 24px;
  min-width: 24px;
  width: 24px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background-color: transparent !important;
  border: 2px solid rgb(229, 230, 231) !important;
}
.step-circle-text-inactive {
  font-weight: 600;
  color: rgb(229, 230, 231) !important;
}
.step-text-inactive {
  font-weight: 600;
  color: rgb(229, 230, 231) !important;
}
.container-profile {
  border-radius: 15px;
  border: 1px solid rgb(229, 230, 231);
  background-color: #fff;
}
div.v-input--selection-controls {
  margin-top: 0 !important;
  padding-top: 0 !important;
}
div.v-messages {
  min-height: 0 !important;
}
.txt-font-label {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: "Sarabun", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 5px;
  color: #757575;
}
.font-style {
  font-family: 'Spartan', sans-serif !important;
}
.txt-font {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 5px;
  color: #757575;
}
.txt-font-value {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
}
.ra-span-text-highlight {
  font-family: "Sarabun", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Color / Neutral / #333333 */

  color: #333333;
}
.ra-layout-empty {
  height: 640px;
  left: 32px;
  right: 32px;
  top: 164px;
}
.ra-head-text-bold {
  font-family: "Sarabun", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Color / Primary / Hover */

  color: #1654c6;
}
.radio-border {
  height: 45px;
  border: 2px solid #ddd;
  border-radius: 5px;
  padding: 15px;
}
.ra-border-button {
  background: #ffffff;
  /* Color / Neutral / #EEEEEE */
  border: 1px solid #eeeeee;
  box-sizing: border-box;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04);
  border-radius: 4px;

  border: 1px solid #eeeeee;
  box-sizing: border-box;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04);
  border-radius: 4px;
}
.ra-text-in-button-employee {
  font-family: "Sarabun", sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
}
</style>
